import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', {
    state: () => ({
        mensagens: [],
    }),

    actions: {
        adicionarMensagem(texto, tipo, duracao = 5000) {
            const id = Date.now()
            this.mensagens.push({ texto, tipo, duracao, id })

            setTimeout(() => {
                this.removerMensagem(id)
            }, duracao)
        },

        removerMensagem(id) {
            const index = this.mensagens.findIndex((msg) => msg.id === id)
            if (index > -1) {
                this.mensagens.splice(index, 1)
            }
        },

        sucesso(texto, duracao) {
            this.adicionarMensagem(texto, 'sucesso', duracao)
        },

        erro(texto, duracao) {
            this.adicionarMensagem(texto, 'erro', duracao)
        },

        aviso(texto, duracao) {
            this.adicionarMensagem(texto, 'aviso', duracao)
        },

        info(texto, duracao) {
            this.adicionarMensagem(texto, 'info', duracao)
        },
    },
})
